import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { BASE_API_URL } from "store/Me";
import moment from "moment";
import { AdminTable } from "components/shared/AdminTable";
import { GuestType } from "./AdminGuests";
import { formatDateOrDefault } from "helpers";

export default function GuestInvites({ guestId }: { guestId: string }) {
  const { data, isError } = useGetGuestInvites(guestId);

  if (isError) {
    return <div>There as an error loading invites.</div>;
  }

  if (data) {
    return (
      <div>
        <AdminTable aria-label="Guest invites" containerClassName="mt-1">
          <thead>
            <tr>
              <th scope="col">Timestamp</th>
              <th scope="col">Valid</th>
              <th scope="col">Note</th>
              <th scope="col">Guest Type</th>
              <th scope="col">Deactivated</th>
            </tr>
          </thead>
          <tbody>
              {data.map((invite) => (
                <tr key={invite.id}>
                  <td>
                    <div>
                      {moment(invite.timestamp).format("YYYY-MM-DD h:mm A")}
                    </div>
                    <div style={{ fontSize: 11, color: "gray" }}>
                      {invite.id}
                    </div>
                  </td>
                  <td>
                    <div>From: {formatDateOrDefault(invite.validFrom)}</div>
                    <div>To: {formatDateOrDefault(invite.validTo)}</div>
                  </td>
                  <td>{invite.note}</td>
                  <td>{invite.guestType}</td>
                  <td>
                    {invite.deactivatedTimestamp ? "Yes" : "No"}
                  </td>
                </tr>
              ))}
          </tbody>
        </AdminTable>
      </div>
    );
  }

  return <div>loading...</div>;
}

export interface GuestInviteResponse {
  id: string;
  timestamp: string;
  updatedTimestamp: string;
  validFrom: string | null;
  validTo: string | null;
  note: string;
  deactivatedTimestamp: string;
  guestType: GuestType;
}

async function getGuestInvites(guestId: string) {
  const url = `${BASE_API_URL}/api/guest/${guestId}/invites`;
  const response = await axios.get<GuestInviteResponse[]>(url);

  return response.data;
}

function useGetGuestInvites(guestId: string) {
  return useQuery({
    queryKey: ["guests", "invites", guestId],
    queryFn: () => getGuestInvites(guestId),
  });
}
